import { useEffect } from "react";

import { useAuth } from "./auth/AuthProvider.js";
import { isWorkspaceRouteName, navigate, resolveRoute, usePathname } from "./lib/routing.js";
import { LandingPage } from "./pages/LandingPage.js";
import { LoginPage } from "./pages/LoginPage.js";
import { SessionLoadingPage, WorkspacePage } from "./pages/Workspace.js";

function NotFoundPage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-950 px-6 text-slate-100">
      <div className="max-w-lg text-center">
        <p className="text-sm font-semibold uppercase tracking-[0.2em] text-cyan-300">404</p>
        <h1 className="mt-4 text-4xl font-semibold">Страница не найдена</h1>
        <p className="mt-4 leading-7 text-slate-400">
          Адрес мог измениться или раздел ещё не подключён к рабочему пространству.
        </p>
        <button
          className="mt-8 rounded-xl bg-cyan-300 px-6 py-3 font-semibold text-slate-950 transition hover:bg-cyan-200"
          onClick={() => navigate("/")}
          type="button"
        >
          На главную
        </button>
      </div>
    </div>
  );
}

export function App() {
  const pathname = usePathname();
  const route = resolveRoute(pathname);
  const auth = useAuth();

  useEffect(() => {
    if (route.protected && auth.status === "anonymous") {
      navigate("/login", { replace: true });
    }
  }, [auth.status, route.protected]);

  if (route.protected && auth.status === "checking") return <SessionLoadingPage />;
  if (route.protected && auth.status !== "authenticated") return <SessionLoadingPage />;

  switch (route.name) {
    case "landing":
      return <LandingPage authenticated={auth.status === "authenticated"} />;
    case "login":
      return <LoginPage />;
    case "not-found":
      return <NotFoundPage />;
    default:
      if (isWorkspaceRouteName(route.name)) return <WorkspacePage routeName={route.name} />;
      return <NotFoundPage />;
  }
}
